import { Params } from '@angular/router';

export class DocumentFilter {
  /**
   * Search keyword.
   */
  public keyword = '';

  /**
   * DocumentFilter constructor.
   *
   * @param data Data from queryParams.
   */
  constructor(data: Params) {
    this.keyword = data.keyword;
  }
}
